export class UploadSellerIdTransactionsError extends Error {}
